
import React, { useState } from "react";
import { useOutsideClick } from "@hooks";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { useNavigate } from 'react-router-dom';

type fn = () => void;

interface MenuOption {
    title: string,
    action: string | fn
}

interface Props {
    menu: React.ReactNode;
    options: MenuOption[];
    chevron: boolean;
    render: (option: MenuOption) => void;
}

const FloatMenu = ({ menu, options, render, chevron = true }: Props) => {

    const ref = useOutsideClick(() => setIsOpen(false));
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const onClick = (action) => {
        setIsOpen(false);
        const call = typeof action === 'string' ? () => navigate(action) : action;
        call();
    }

    // TODO fix this type error
    const liOptions: any = options.map(option => {
        const { title, action } = option;
        return render({ title, action: () => onClick(action) })
    });

    return (
        <div ref={ref}>
            <button onClick={() => setIsOpen(!isOpen)}
                className="background-transparent text-blue-text outline-none text-sm focus:outline-none">
                <div className="flex flex-row flex-nowrap items-center">
                    {menu}
                    {chevron && !isOpen && <ChevronDownIcon className="h-5 text-blue-text inline" />}
                    {chevron && isOpen && <ChevronUpIcon className="h-5 text-blue-text inline" />}
                </div>
            </button>
            {
                isOpen &&
                <ul className="z-10 absolute bg-white list-none rounded-xl shadow-sb">{liOptions}</ul>
            }
        </div>
    );
}

export default FloatMenu;